import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function macAddressValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const macRegex = /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/i;
    if (control.value && !macRegex.test(control.value)) {
      return { invalidMacAddress: true };
    }
    return null;
  };
}
